<template lang="pug" src="./receiveOrders.pug"> </template>
<style lang="scss" src="./receiveOrders.scss" scoped> </style>

<script>

import map from '@/components/map';
import ordersLayout from '@/views/pages/ReceiveOrders/orders-layout';
import ordersHistory from '@/views/pages/History';
import navigation from '@/components/navigation';
import { mapState } from 'vuex';
import notify from '@/plugins/notify';
import config from '../../../../config.json';

export default {
    components: {
        'v-map': map,
        'v-orders': ordersLayout,
        'v-history': ordersHistory,
        'v-navigation': navigation,
    },
    computed: {
        ...mapState({
            driversMap: (state) => state.map.driversMap,
            isShowHistory: (state) => state.orders.isShowHistory,
            drawer: (state) => state.data.drawer
        })
    },
    beforeRouteLeave(to, from, next) {
        this.$store.commit('orders/SET_CALL_SIGN', null);
        this.$store.commit('orders/SET_ACTIVE_DRIVER', null);
        next();
    },
    mounted: function() {
        if (config.browserNotifications) {
            notify.initNotify();
        }
    }
};
</script>
